module.exports = "/static/img/japan.dzi";


//////////////////
// WEBPACK FOOTER
// ./src/img/japan.dzi
// module id = 393
// module chunks = 0